(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[227],{

/***/ 74383:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/[id]",
      function () {
        return __webpack_require__(21230);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 24331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10990);
/* harmony import */ var gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39664);
/* harmony import */ var gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_1__);


gsap__WEBPACK_IMPORTED_MODULE_0__/* ["default"].registerPlugin */ .ZP.registerPlugin((gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_1___default()));
var useMobileAccordion = function() {
    var mobileAccordion = function(id) {
        if (id === 1) {
            gsap__WEBPACK_IMPORTED_MODULE_0__/* ["default"].to */ .ZP.to(window, {
                duration: 0.1,
                scrollTo: {
                    y: "#website_accordion",
                    offsetY: 0
                }
            });
        }
        if (id === 2) {
            gsap__WEBPACK_IMPORTED_MODULE_0__/* ["default"].to */ .ZP.to(window, {
                duration: 0.1,
                scrollTo: {
                    y: "#apps_accordion",
                    offsetY: 0
                }
            });
        }
        if (id === 3) {
            gsap__WEBPACK_IMPORTED_MODULE_0__/* ["default"].to */ .ZP.to(window, {
                duration: 0.1,
                scrollTo: {
                    y: "#ecom_accordion",
                    offsetY: 0
                }
            });
        }
        if (id === 4) {
            gsap__WEBPACK_IMPORTED_MODULE_0__/* ["default"].to */ .ZP.to(window, {
                duration: 0.1,
                scrollTo: {
                    y: "#strategy_accordion",
                    offsetY: 0
                }
            });
        }
    };
    var caseMobileAccordion = function(i) {
        if (i === 0) {
            gsap__WEBPACK_IMPORTED_MODULE_0__/* ["default"].to */ .ZP.to(window, {
                duration: 1,
                scrollTo: {
                    y: "#case",
                    offsetY: 0
                }
            });
        }
        if (i === 1) {
            gsap__WEBPACK_IMPORTED_MODULE_0__/* ["default"].to */ .ZP.to(window, {
                duration: 1,
                scrollTo: {
                    y: "#case",
                    offsetY: -60
                }
            });
        }
    };
    return {
        mobileAccordion: mobileAccordion,
        caseMobileAccordion: caseMobileAccordion
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useMobileAccordion);


/***/ }),

/***/ 21230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(97650);
// EXTERNAL MODULE: ./src/constant/index.tsx + 38 modules
var constant = __webpack_require__(17089);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/icons/SiArrowDownIcon.tsx

var SiArrowDownIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        stroke: "currentColor",
        fill: "currentColor",
        strokeWidth: "0",
        viewBox: "0 0 1024 1024",
        height: "1em",
        width: "1em",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M8.2 275.4c0-8.6 3.4-17.401 10-24.001 13.2-13.2 34.8-13.2 48 0l451.8 451.8 445.2-445.2c13.2-13.2 34.8-13.2 48 0s13.2 34.8 0 48L542 775.399c-13.2 13.2-34.8 13.2-48 0l-475.8-475.8c-6.8-6.8-10-15.4-10-24.199z"
        })
    });
};
/* harmony default export */ var icons_SiArrowDownIcon = (SiArrowDownIcon);

;// CONCATENATED MODULE: ./src/views/Project/components/CaseCounterSection/CaseCounterSection.tsx



var CaseCounterSection = function(param) {
    var data = param.data, countdown = param.countdown, targetRef = param.targetRef, isVisible = param.isVisible, nextUrl = param.nextUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: ".__bgImg {\n               background-image: url(".concat((data === null || data === void 0 ? void 0 : data.imageUrlLong) ? data === null || data === void 0 ? void 0 : data.imageUrlLong : "/imgs/sliders/1-long.png", ")\n            }")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: nextUrl,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "h-[555px] text-center relative  text-white overflow-hidden bg-cover bg-center bg-no-repeat w-full __bgImg bg-[#4c4c4c]",
                    id: "countDown",
                    ref: targetRef,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "font-[800] text-[240px] md:text-[336px] lg:text-[512px] text-white/40 absolute left-[50%] top-[50%] -translate-x-2/4 -translate-y-2/4 z-99 ".concat(isVisible ? "opacity-100 transition-opacity duration-500" : "opacity-0 transition-opacity duration-500"),
                            children: isVisible ? "0".concat(countdown) : null
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "bg-black/75 w-full h-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "absolute left-[50%] top-[50%] -translate-x-2/4 -translate-y-2/4 z-999 w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "uppercase text-[14px] leading-5 tracking-[2px]",
                                        children: "Next case"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "my-[24px] text-[28px] leading-[18px] font-[600]",
                                        children: data === null || data === void 0 ? void 0 : data.imageTitle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "font-[400] text-[23px]",
                                        children: data === null || data === void 0 ? void 0 : data.imageDesc
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "flex items-center justify-center mt-[10px] text-[20px] font-[800]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_SiArrowDownIcon, {})
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var CaseCounterSection_CaseCounterSection = (CaseCounterSection);

;// CONCATENATED MODULE: ./src/views/Project/components/CaseCounterSection/index.ts



// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/gsap/dist/gsap.js
var gsap = __webpack_require__(89521);
// EXTERNAL MODULE: ./src/hooks/useMobileAccordion.tsx
var useMobileAccordion = __webpack_require__(24331);
// EXTERNAL MODULE: ./node_modules/gsap/index.js + 1 modules
var node_modules_gsap = __webpack_require__(10990);
// EXTERNAL MODULE: ./node_modules/react-collapsible/dist/index.js
var dist = __webpack_require__(97893);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
;// CONCATENATED MODULE: ./src/icons/FaPlusIcon.tsx

var FaPlusIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        stroke: "currentColor",
        fill: "currentColor",
        strokeWidth: "0",
        viewBox: "0 0 448 512",
        height: "1em",
        width: "1em",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
        })
    });
};
/* harmony default export */ var icons_FaPlusIcon = (FaPlusIcon);

;// CONCATENATED MODULE: ./src/views/Project/components/OverviewSection/OverviewSection.tsx







var OverviewSection = function(param) {
    var data = param.data;
    var ref = (0,react.useState)(null), activeCollapse = ref[0], setActiveCollapse = ref[1];
    var caseMobileAccordion = (0,useMobileAccordion/* default */.Z)().caseMobileAccordion;
    var tl = node_modules_gsap/* default.timeline */.ZP.timeline({
        defaults: {
            duration: 1.4
        }
    });
    (0,react.useEffect)(function() {
        tl.to("._caseStudiesLeftOverView, ._caseStudiesRightOverView", {
            opacity: 1,
            x: 0,
            delay: 0.2
        }, "start");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleCollapse = function(i) {
        setActiveCollapse(function(prev) {
            return prev === i ? null : i;
        });
        if (i !== activeCollapse) {
            caseMobileAccordion(i);
        }
    };
    var collapsebleData = [
        {
            title: "THE CHALLENGE",
            desc: data === null || data === void 0 ? void 0 : data.challenge
        },
        {
            title: "THE SOLUTION",
            desc: data === null || data === void 0 ? void 0 : data.solution
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-1 text-white lg:grid-cols-2 lg:-mt-[5rem]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid w-full grid-cols-1 px-[8.33333%] lg:pr-0 pb-[1.07143rem] lg:pb-0 bg-primary lg:grid-cols-2 lg:pl-[5rem] lg:pt-[5rem] opacity-0 -translate-x-8 _caseStudiesLeftOverView",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full lg:pt-[1.78571rem] lg:pb-[2.85714rem] lg:pl-[4.53782vw]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "grid grid-cols-[66.6666%_33.3333%] items-start w-full lg:space-y-5 lg:inline-block",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "space-y-3 lg:space-y-5",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "leading-[1.23077em] text-[.92857rem] font-semibold uppercase mb-[0.71429rem] mt-[2.14286rem] lg:my-[1.78571rem]",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                        className: "tracking-[0.13286rem]",
                                                        children: "CLIENT"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "text-[1rem] m-0",
                                                    children: data === null || data === void 0 ? void 0 : data.client
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "space-y-3 lg:space-y-5",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "leading-[1.23077em] text-[.92857rem] font-semibold uppercase mb-[0.71429rem] mt-[2.14286rem] lg:my-[1.78571rem]",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                        className: "tracking-[0.13286rem]",
                                                        children: "YEAR"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "text-[1rem] m-0",
                                                    children: data === null || data === void 0 ? void 0 : data.year
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "space-y-3 list-disc list-inside lg:pt-[1.78571rem] lg:pb-[2.85714rem] lg:space-y-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "leading-[1.23077em] text-[.92857rem] font-semibold uppercase mb-[0.71429rem] mt-[2.14286rem] lg:my-[1.78571rem] tracking-[0.13286rem]",
                                        children: "ACTIVITIES"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "!mt-[1.42857rem] text-[1rem] m-0",
                                        children: data === null || data === void 0 ? void 0 : data.activities.map(function(item) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "block mb-[0.71429rem] lg:mb-[1.64286rem] pl-[1.78571rem] relative text-[1rem] before:content-[''] before:w-[3px] before:h-[3px] before:top-[0.42857rem] before:left-0 before:bg-white before:rounded-full before:absolute last:mb-[0.71429rem]",
                                                children: item
                                            }, item);
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-[8.33333%] lg:pl-[10%] lg:pr-[5rem] lg:pb-[2.5rem] lg:pt-[5rem] pb-[1.07143rem] bg-redblack space-y-7 opacity-0 translate-x-8 _caseStudiesRightOverView",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                className: "text-[0.92857rem] font-semibold tracking-[0.13071rem] uppercase mt-[1.78571rem] lg:mt-[3.57143rem] mb-[1.67em]",
                                children: "THE OVERVIEW"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "text-[1.28571rem] leading-[1.22222em] lg:leading-[1.22727em] font-[300] lg:text-[1.57143rem] lg:pr-[3.85714rem] lg:!mt-[3rem] !my-[1em]",
                                children: data === null || data === void 0 ? void 0 : data.overview
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "lg:mt-[2.64286rem] lg:pb-[3.57143rem]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex lg:relative lg:pt-[1.71429rem] lg:pb-[4.28571rem] lg:mb-[3.57143rem] lg:after:content-[''] lg:after:h-[1px] lg:after:bg-[#e4e4e4] lg:after:absolute lg:after:bottom-0 lg:after:left-[8.33333%] lg:after:right-[8.33333%]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "hidden lg:max-w-[50%] lg:pl-[5rem] lg:pb-0 lg:pr-[4.53782vw] text-black lg:block space-y-7",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    className: "lg:pl-[4.53782vw] lg:leading-[1.28571em] lg:mb-[2.14286rem] lg:mt-[1.67em] lg:text-[0.92857rem] font-semibold tracking-[0.13286rem]",
                                    children: "THE CHALLENGE"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "h-auto lg:pl-[4.53782vw] lg:leading-[1.28571em] !my-[1em] text-[#131313]",
                                    children: data === null || data === void 0 ? void 0 : data.challenge
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "hidden lg:max-w-[50%] lg:pl-[5%] lg:pr-[5rem] lg:pb-0 text-black lg:block space-y-7",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    className: "lg:leading-[1.28571em] lg:mb-[2.14286rem] lg:mt-[1.67em] lg:text-[0.92857rem] font-semibold tracking-[0.13286rem]",
                                    children: "THE SOLUTION"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "h-auto lg:leading-[1.28571em] !my-[1em] text-[#131313]",
                                    children: data === null || data === void 0 ? void 0 : data.solution
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "case",
                            className: "mt-[2.64286rem] mb-[3.57143rem] lg:hidden",
                            children: collapsebleData.map(function(param, i) {
                                var title = param.title, desc = param.desc;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    id: "case".concat(i),
                                    className: "px-[8.33333%] first-of-type:mb-8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                            className: "cursor-pointer relative my-[1rem] font-semibold text-[.92857rem] tracking-[.13286rem] flex justify-between",
                                            onClick: function() {
                                                return handleCollapse(i);
                                            },
                                            children: [
                                                title,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: classnames_default()("duration-200 mr-[-8px] text-xl text-black/20", activeCollapse === i && "rotate-45"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_FaPlusIcon, {})
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                                            trigger: "",
                                            open: i === activeCollapse,
                                            transitionTime: 200,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "m-[0_0_1rem] lg:m-0 text-[#131313] leading-[1.42857em] text-[14px] pb-[3px] p-0",
                                                children: desc
                                            })
                                        })
                                    ]
                                }, "fjdgfrhd_" + i);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var OverviewSection_OverviewSection = (OverviewSection);

;// CONCATENATED MODULE: ./src/views/Project/components/OverviewSection/index.ts



;// CONCATENATED MODULE: ./src/views/Project/components/HeroSection/HeroSection.tsx
/* eslint-disable @next/next/no-img-element */ 





function HeroSection(param) {
    var data = param.data, isBlack = param.isBlack;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var tl = gsap.gsap.timeline({
        defaults: {
            duration: 1.4
        }
    });
    (0,react.useLayoutEffect)(function() {
        window.requestAnimationFrame(function() {
            tl.to("._topMoreButton", {
                opacity: 1,
                x: 0,
                delay: 0.5
            }, "start").to("._caseStudiesIntro", {
                opacity: 1,
                x: 0,
                delay: 0.5
            }, "start").to("._caseStudiesDec, ._caseStudiesRightDots", {
                opacity: 1,
                y: 0,
                delay: 0.5
            }, "start");
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    });
    var fullCaseStudyIds = [
        11,
        12,
        13
    ];
    console.log(isBlack);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-full relative z-[2] lg:flex lg:flex-wrap lg:flex-row",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hidden lg:flex-[0_0_auto] lg:w-[5rem] lg:pt-[5rem] lg:block lg:relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/case-study",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "bg-transparent",
                            href: "#",
                            "aria-label": "case study page",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute top-0 bottom-0 left-0 right-0 flex items-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "header_case_side_link min-h-[200px] text-center m-auto inline-block text-[#000] font-bold hover:text-primary duration-300 group",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "inline-block align-middle leading-[1.07143rem] w-[1.07143rem] h-[1.07143rem] mb-[0.71429rem] relative pointer-events-none header_case_side_link_square group-hover:rotate-90",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "bg-primary top-0 left-0 absolute w-[0.42857rem] h-[0.42857rem] pointer-events-none"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "bg-primary top-0 right-0 absolute w-[0.42857rem] h-[0.42857rem] pointer-events-none"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "bg-primary bottom-0 left-0 absolute w-[0.42857rem] h-[0.42857rem] pointer-events-none"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "bg-primary bottom-0 right-0 absolute w-[0.42857rem] h-[0.42857rem] pointer-events-none"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "inline-block align-middle leading-[1.07143rem] pointer-events-none",
                                            children: "All case studies"
                                        })
                                    ]
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative z-[1] lg:flex-grow lg:shrink lg:basis-[0%] lg:mt-[5rem]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            (data === null || data === void 0 ? void 0 : (ref = data.heroSectionData) === null || ref === void 0 ? void 0 : ref.videoSrc) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "hidden lg:block",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                            className: "h-[calc(100svh-10rem)] w-full object-cover",
                                            autoPlay: true,
                                            muted: true,
                                            loop: true,
                                            playsInline: true,
                                            poster: data === null || data === void 0 ? void 0 : (ref1 = data.heroSectionData) === null || ref1 === void 0 ? void 0 : ref1.imageUrlLong,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                src: data === null || data === void 0 ? void 0 : (ref2 = data.heroSectionData) === null || ref2 === void 0 ? void 0 : ref2.videoSrc
                                            })
                                        }, data === null || data === void 0 ? void 0 : (ref3 = data.heroSectionData) === null || ref3 === void 0 ? void 0 : ref3.id)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "lg:hidden block",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                            className: "m-0 relative block before:content-[''] before:top-0 before:bottom-0 before:left-0 before:right-0 before:absolute before:bg-[#000] lg:before:bg-transparent before:opacity-[0.3]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: data === null || data === void 0 ? void 0 : (ref4 = data.heroSectionData) === null || ref4 === void 0 ? void 0 : ref4.imageUrlSmall,
                                                alt: "banner",
                                                // loading="lazy"
                                                className: "w-full max-w-full min-h-[100svh] landscape:max-h-[100svh] block lg:hidden h-[calc((5.62px,1vh)*100)] object-cover object-center"
                                            })
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                                className: "m-0 relative block before:content-[''] before:top-0 before:bottom-0 before:left-0 before:right-0 before:absolute before:bg-[#000] lg:before:bg-transparent before:opacity-[0.3]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: data === null || data === void 0 ? void 0 : (ref5 = data.heroSectionData) === null || ref5 === void 0 ? void 0 : ref5.imageUrlLong,
                                        alt: "banner",
                                        // loading="lazy"
                                        className: "w-[calc(100svw-11.18rem)] max-w-full hidden lg:block h-[calc(100svh-10rem)] object-cover bg-[#f5f5f5] object-center"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: data === null || data === void 0 ? void 0 : (ref6 = data.heroSectionData) === null || ref6 === void 0 ? void 0 : ref6.imageUrlSmall,
                                        alt: "banner",
                                        // loading="lazy"
                                        className: "w-full max-w-full min-h-[100svh] landscape:max-h-[100svh] block lg:hidden h-[calc((5.62px,1vh)*100)] object-cover object-center"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "absolute top-0 bottom-0 left-0 right-0 lg:flex before:content-[''] before:table after:content-[''] after:table after:clear-both",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "lg:flex-grow lg:shrink lg:basis-[0%]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "absolute bottom-[2.14286rem] left-[8.33333%] right-[16.66667%] lg:top-1/2 lg:bottom-auto lg:left-[4.53782vw] lg:translate-y-[-50%] z-10",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                                        className: "pl-[2.85714rem] uppercase text-[0.92857rem] tracking-[0.13286rem] text-white font-semibold leading-[1.1875em] translate-x-8 _caseStudiesIntro relative my-[1.33em] after:bg-primary after:left-0 after:absolute after:top-[50%] after:translate-y-[-50%] after:h-[2px] after:w-[1.5rem] after:content-[''] ".concat(isBlack ? "lg:text-black" : ""),
                                                        children: [
                                                            fullCaseStudyIds.includes(data === null || data === void 0 ? void 0 : data.id) && "FULL",
                                                            " CASE STUDIES"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                        className: "md:text-[1.85714rem] text-[1.57143rem] my-[0.71429rem] md:leading-[1.23077em] leading-[1.22727em] tracking-normal font-bold text-white opacity-0 translate-x-8 _caseStudiesIntro ".concat(isBlack ? "lg:text-black" : ""),
                                                        children: (data === null || data === void 0 ? void 0 : (ref7 = data.heroSectionData) === null || ref7 === void 0 ? void 0 : ref7.imageTitle) ? data === null || data === void 0 ? void 0 : (ref8 = data.heroSectionData) === null || ref8 === void 0 ? void 0 : ref8.imageTitle : "Verizon"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: "m-0 relative text-[1.57143rem] font-[400] leading-[1.22727em] tracking-normal text-white opacity-0 translate-y-8 _caseStudiesDec ".concat(isBlack ? "lg:text-black" : ""),
                                                        children: (data === null || data === void 0 ? void 0 : (ref9 = data.heroSectionData) === null || ref9 === void 0 ? void 0 : ref9.imageDesc) ? data === null || data === void 0 ? void 0 : (ref10 = data.heroSectionData) === null || ref10 === void 0 ? void 0 : ref10.imageDesc : "Sub Pages Redesign"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: classnames_default()("cursor-pointer items-center justify-center w-0.5 hidden lg:flex", "_topMoreButton"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "-rotate-90 -translate-y-10 relative -mt-5",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: classnames_default()("inline-block w-[150px] h-[2px] bg-white/60 -translate-x-full", "_topMoreButtonLine", isBlack && "lg:bg-black/80")
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute bottom-0 right-0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    onClick: function() {
                                                        return window.scrollTo(0, 910);
                                                    },
                                                    className: classnames_default()("absolute lg:hidden text-white w-[5rem] h-[15rem] bottom-0 border-0 right-0 bg-transparent cursor-pointer", "_topMoreButton opacity-0 -translate-x-8"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-white rotate-90 translate-y-[-1rem] text-[0.92857rem] relative block",
                                                            children: "More"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: classnames_default()("inline-block w-[46px] h-[2px] -rotate-90 bg-white -translate-x-[50%]  mt-0  absolute !bottom-[3.75rem]", "_topMoreButtonLine")
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute top-0 bottom-0 left-0 right-0 pointer-events-none lg:flex-grow lg:shrink lg:basis-[0%] lg:relative",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "case_study_dots opacity-0 translate-y-10 _caseStudiesRightDots"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hidden lg:flex-[0_0_auto] lg:w-[5rem] lg:pt-[5rem] lg:block lg:relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/case-study/".concat(parseInt(data === null || data === void 0 ? void 0 : (ref11 = data.heroSectionData) === null || ref11 === void 0 ? void 0 : ref11.id) === 13 ? 1 : parseInt(data === null || data === void 0 ? void 0 : (ref12 = data.heroSectionData) === null || ref12 === void 0 ? void 0 : ref12.id) + 1),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute top-0 bottom-0 left-0 right-0 flex items-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "#",
                                "aria-label": "case study single page",
                                className: "header_case_side_link min-h-[200px] text-center m-auto inline-block text-[#000] font-bold leading-[1.42857em] hover:text-primary duration-300",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "inline-block align-middle leading-[1.07143rem] pointer-events-none",
                                    children: "Next"
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(OverviewSection_OverviewSection, {
                    data: data === null || data === void 0 ? void 0 : data.overviewSectionData
                })
            ]
        })
    });
}
/* harmony default export */ var HeroSection_HeroSection = (HeroSection);

;// CONCATENATED MODULE: ./src/views/Project/components/HeroSection/index.ts



// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/views/Project/Project.tsx








var P1LandingPageSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2055), __webpack_require__.e(3934)]).then(__webpack_require__.bind(__webpack_require__, 53934));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53934)
            ];
        }
    }
});
var P2LandingPageSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5172).then(__webpack_require__.bind(__webpack_require__, 5172));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5172)
            ];
        }
    }
});
var P3LandingPageSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1350).then(__webpack_require__.bind(__webpack_require__, 91350));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91350)
            ];
        }
    }
});
var P4LandingPageSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6656).then(__webpack_require__.bind(__webpack_require__, 66656));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(66656)
            ];
        }
    }
});
var P5LandingSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5393).then(__webpack_require__.bind(__webpack_require__, 85393));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85393)
            ];
        }
    }
});
var P6LandingPageSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9856).then(__webpack_require__.bind(__webpack_require__, 49856));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49856)
            ];
        }
    }
});
var P7LandingPageSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3984).then(__webpack_require__.bind(__webpack_require__, 83984));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83984)
            ];
        }
    }
});
var P8LandingSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4564).then(__webpack_require__.bind(__webpack_require__, 94564));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94564)
            ];
        }
    }
});
var P9LandingSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8291).then(__webpack_require__.bind(__webpack_require__, 8291));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8291)
            ];
        }
    }
});
var P10LandingSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3303).then(__webpack_require__.bind(__webpack_require__, 33303));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(33303)
            ];
        }
    }
});
var P11LandingSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5166).then(__webpack_require__.bind(__webpack_require__, 95166));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95166)
            ];
        }
    }
});
var P12LandingSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9303).then(__webpack_require__.bind(__webpack_require__, 59303));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59303)
            ];
        }
    }
});
var P13LandingSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8936).then(__webpack_require__.bind(__webpack_require__, 28936));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28936)
            ];
        }
    }
});
function Project() {
    var router = (0,next_router.useRouter)();
    var id = router.query.id;
    // hooks
    var ref = (0,react_intersection_observer_modern/* useInView */.YD)({
        delay: 900,
        rootMargin: "-50% 0% -50% 0%"
    }), targetRef = ref.ref, isVisible = ref.inView, entry = ref.entry;
    // states
    var ref1 = (0,react.useState)([]), pageData = ref1[0], setPageData = ref1[1];
    var ref2 = (0,react.useState)([]), nextdata = ref2[0], setNextData = ref2[1];
    var ref3 = (0,react.useState)(3), countdown = ref3[0], setCountdown = ref3[1];
    var allSliderData = [];
    constant/* caseStudyProjectsData.map */.iY.map(function(item) {
        allSliderData.push(item.heroSectionData);
    });
    (0,react.useEffect)(function() {
        setNextData(allSliderData.find(function(item) {
            return item.id === (Number(id) === 13 ? 1 : Number(id) + 1);
        }));
        setPageData(constant/* caseStudyProjectsData.find */.iY.find(function(item) {
            return item.id.toString() === id;
        }));
    }, [
        id,
        allSliderData
    ]);
    (0,react.useEffect)(function() {
        var interval;
        if (isVisible && countdown == 0) {
            // @ts-ignore
            router.push("/case-study/".concat(parseInt(id) === 13 ? 1 : parseInt(id) + 1));
        // setCountdown(3);
        }
        if (isVisible) {
            interval = setInterval(function() {
                setCountdown(countdown - 1);
            }, 1200);
        } else {
            setCountdown(3);
        }
        // else {
        //   setTimeout(() => {
        //     setCountdown(3);
        //   }, 3000);
        // }
        return function() {
            clearInterval(interval);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isVisible,
        countdown
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "overflow-x-hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSection_HeroSection, {
                isBlack: [
                    1,
                    8,
                    12
                ].includes(Number(id)),
                data: pageData
            }),
            id === "1" && /*#__PURE__*/ (0,jsx_runtime.jsx)(P1LandingPageSection, {
                data: pageData === null || pageData === void 0 ? void 0 : pageData.landingPageSectionData,
                id: id
            }),
            id === "2" && /*#__PURE__*/ (0,jsx_runtime.jsx)(P2LandingPageSection, {
                data: pageData === null || pageData === void 0 ? void 0 : pageData.landingPageSectionData,
                id: id
            }),
            id === "3" && /*#__PURE__*/ (0,jsx_runtime.jsx)(P3LandingPageSection, {}),
            id === "4" && /*#__PURE__*/ (0,jsx_runtime.jsx)(P4LandingPageSection, {}),
            id === "5" && /*#__PURE__*/ (0,jsx_runtime.jsx)(P5LandingSection, {}),
            id === "6" && /*#__PURE__*/ (0,jsx_runtime.jsx)(P6LandingPageSection, {}),
            id === "7" && /*#__PURE__*/ (0,jsx_runtime.jsx)(P7LandingPageSection, {}),
            id === "8" && /*#__PURE__*/ (0,jsx_runtime.jsx)(P8LandingSection, {}),
            id === "9" && /*#__PURE__*/ (0,jsx_runtime.jsx)(P9LandingSection, {}),
            id === "10" && /*#__PURE__*/ (0,jsx_runtime.jsx)(P10LandingSection, {}),
            id === "11" && /*#__PURE__*/ (0,jsx_runtime.jsx)(P11LandingSection, {}),
            id === "12" && /*#__PURE__*/ (0,jsx_runtime.jsx)(P12LandingSection, {}),
            id === "13" && /*#__PURE__*/ (0,jsx_runtime.jsx)(P13LandingSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseCounterSection_CaseCounterSection, {
                data: nextdata,
                countdown: countdown,
                targetRef: targetRef,
                isVisible: isVisible,
                nextUrl: "/case-study/".concat(parseInt(id) === 13 ? 1 : parseInt(id) + 1)
            })
        ]
    });
}
/* harmony default export */ var Project_Project = (Project);

;// CONCATENATED MODULE: ./src/views/Project/index.ts



;// CONCATENATED MODULE: ./src/pages/case-study/[id].tsx



var ProjectPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Project_Project, {});
};
/* harmony default export */ var _id_ = (ProjectPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6770,9774,2888,179], function() { return __webpack_exec__(74383); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);